import React, { useState } from 'react';
import {
  Form,
  Row,
  Spin,
  Modal,
  Button,
  Space,
  Input,
  InputNumber,
} from 'antd';
import { message, FormLabel } from 'components/common';
import {
  LoadingOutlined,
  SaveOutlined,
  PlusOutlined,
  CloseOutlined,
} from '@ant-design/icons';
// import { LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';
import { addSortAreas, editSortAreas } from 'services/warehouse';

interface AddProps {
  visible: boolean;
  onHide: () => void;
  onRefresh: () => void;
  sortArea?: any;
  warehouse: any;
}

// eslint-disable-next-line
export default (props: AddProps) => {
  const { visible, onHide, onRefresh, sortArea, warehouse } = props;
  const [submitLoading, setSubmitLoading] = useState(false);

  const [form] = Form.useForm();

  const handleSubmit = async () => {
    const params = await form.validateFields();
    if (params.errorFields) return;

    try {
      setSubmitLoading(true);
      let res;
      if (!sortArea) {
        res = await addSortAreas(warehouse.warehouseId, JSON.stringify(params));
      } else {
        res = await editSortAreas(sortArea.sortAreaNum, JSON.stringify(params));
      }
      setSubmitLoading(false);
      if (res.isSuccess) {
        message.success({
          content: sortArea ? 'Saved successfully' : 'Added successfully',
        });
        onRefresh();
        onHide();
      }
    } catch (error) {
      setSubmitLoading(false);
    }
  };

  const handleCancel = () => {
    const cancel = form.isFieldsTouched();
    if (!cancel) {
      onHide();
    } else {
      Modal.confirm({
        title: 'Leave / Refresh Page?',
        okText: 'Leave',
        cancelText: 'Cancel',
        content: `Changes you made may not be saved.`,
        onOk() {
          onHide();
        },
      });
    }
  };

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 14 },
  };
  return (
    <Modal
      title={`${sortArea ? 'Edit' : 'Add'} SortAreas for ${
        warehouse.warehouseCode
      }`}
      centered
      visible={visible}
      maskClosable={false}
      width={600}
      destroyOnClose={true}
      onCancel={handleCancel}
      getContainer={false}
      footer={
        <Row justify="end">
          <Space>
            <Button
              id="flat_modal_edit_or_save_button"
              key="submit"
              type="primary"
              onClick={handleSubmit}
              loading={submitLoading}
            >
              {sortArea ? <SaveOutlined /> : <PlusOutlined />}
              {submitLoading
                ? `${sortArea ? 'Saving' : 'Adding'}`
                : `${sortArea ? 'Save' : 'Add'}`}
            </Button>
            <Button
              id="edit_add_flat_modal_cancl_button"
              onClick={handleCancel}
              icon={<CloseOutlined />}
            >
              Cancel
            </Button>
          </Space>
        </Row>
      }
    >
      <Spin
        spinning={submitLoading}
        indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
      >
        <Form {...layout} form={form}>
          <Form.Item
            name="SortAreaCode"
            initialValue={sortArea?.sortAreaCode}
            label={<FormLabel>Code</FormLabel>}
            rules={[{ required: true, message: 'Please input code!' }]}
          >
            <Input disabled={!!sortArea} />
          </Form.Item>

          <Form.Item
            name="Name"
            initialValue={sortArea?.name}
            label={<FormLabel>Name</FormLabel>}
            rules={[{ required: true, message: 'Please input name!' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="Ratio"
            initialValue={sortArea?.ratio || 0}
            label={<FormLabel>Ratio</FormLabel>}
          >
            <InputNumber min={0} precision={0} />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};
